// removed by extract-text-webpack-plugin
module.exports = {"image":"ResponsiveImage-module-image-2DNsi","responsive":"ResponsiveImage-module-responsive-2l0HC","container":"ResponsiveImage-module-container-j_cPo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResponsiveImage/ResponsiveImage.module.scss
// module id = 1202
// module chunks = 0